import { useEffect, useState } from "react";
import { addDays, format, isToday } from "date-fns";
import { IoSearch } from "react-icons/io5";
import calculadoraIcon from "../../../../../assets/icons/calculadora.svg";
import handGreenIcon from "../../../../../assets/icons/hand_green.svg";
import handRedIcon from "../../../../../assets/icons/hand_red.svg";
import { ParametroSimulacao } from "./components/simulacao";
import { ResumoAcordo } from "./components/resumo";
import { ContratoData } from "./components/contratoData";
import { ClienteInfo } from "../cliente-info";
import { ModalAviso } from "../../../../Modal/components/aviso";
import { useModal } from "../../../../../hooks/ModalContext";
import { GenericModal } from "../../../../Modal";
import { useContrato } from "../../../../../context/ContratoContext";
import { useDividas } from "../../../../../context/DividasContext";
import {
  RequestParamsSimulate,
  RequestSimularParametros,
  useNeg,
} from "../../../../../context/NegContext";
import { useFila } from "../../../../../context/FilaContext";
import { converterParaNumeroAmericano } from "../../../../../utils/convertNumbers";
// import { credoresGazin } from "../../../../../utils/credoresGazin";
import { CanaisEnvio } from "../form-neg/components/canais-envio/CanalEnvioTesteRefeito";
import { SimularAcordoData } from "../../../../../types/simular-acordo-interface";
import { useAuth } from "../../../../../context/AuthContext";
import moment from "moment";

interface FormNegProps {
  isCaixa?: boolean
}

export const FormNeg = ({ isCaixa }: FormNegProps) => {
  const { setModal, modalInfo, onClose } = useModal();
  const { contratosData } = useContrato();
  const { devedorCadastro, devedor, selectedCredor } = useDividas();
  const {
    parcelasNeg,
    getParamsSimulate,
    simulacaoAP,
    simulacaoAV,
    simulacaoAPJP,
    simulacaoJPParcela,
    contratoNeg,
    valoresSimulacao,
    simulcaoCalculadora,
    calcularValores,
    descontos,
    valorEntrada,
    percentualEntrada,
    setSimulacaoCalculadora,
  } = useNeg();
  // const { devedorFilaSelected } = useFila();
  const { cookies } = useAuth();
  const app = isCaixa ? 'ACIONA_CXA' : 'ACIONA_OPE'

  const [tipoNeg, setTipoNeg] = useState("AV");
  const [qtdParcelas, setQtdParcelas] = useState("");
  const [vencimento, setVencimento] = useState(
    format(new Date(), "yyyy-MM-dd")
  );
  const [formaPagamento, setFormaPagamento] = useState("Pgto em loja");
  // const [valorEntrada, setValorEntrada] = useState('')

  useEffect(() => {
    setSimulacaoCalculadora({} as SimularAcordoData);
    const element = document.getElementById("resumo");
    if (element) {
      document.getElementById("resumo")?.setAttribute("open", "false");
    }
  }, [tipoNeg, formaPagamento]);

  function goToOpeningAccordion(id: string) {
    const element = document.getElementById(id);
    if (element) {
      document.getElementById(id)?.setAttribute("open", "true");
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  async function paramsSimulate() {
    if (parcelasNeg?.length === 0) {
      setModal("Selecione pelo menos uma parcela para fazer a operação!", "Aviso", false, true);
      return
    }
    const params: RequestParamsSimulate = {
      url: selectedCredor?.url_ws,
      codcredor: String(selectedCredor?.credor_crm),
      cpf_cnpj: devedorCadastro?.cpfcnpj,
      tipo: tipoNeg,
      formapagamento: formaPagamento === "Boleto" ? "1" : "4",
      usuario: String(cookies?.user?.id_operador),
      contratos: parcelasNeg?.map((p) => {
        return {
          idparcial: p.idparcial,
          numcontrato: p.contrato,
          valpago: p.valorpago,
          filial: p.filial,
          datvenci: p.datvenci,
          numeroparcela: p.numeroparcela,
        };
      }),
      app
    };
    // console.log(params)
    await getParamsSimulate(params);
  }

  useEffect(() => {
    if (simulacaoAV.cpfcnpj && !simulacaoAP.cpfcnpj) {
      paramsSimulate();
    }
    if (tipoNeg === "AV") {
      setQtdParcelas("1");
    }
  }, [tipoNeg]);

  useEffect(() => {
    if (simulacaoAP?.codcredor === "2000") {
      simulacaoJPParcela(qtdParcelas);
    }
  }, [qtdParcelas]);

  function getMaxDays() {
    if (
      tipoNeg === "AP" &&
      simulacaoAP?.cpfcnpj &&
      simulacaoAP.regrassimularacordo.dias_primeira_parcela_max
    ) {
      return format(
        addDays(
          new Date(),
          Number(simulacaoAP.regrassimularacordo.dias_primeira_parcela_max) - 1
        ),
        "yyyy-MM-dd"
      );
    } else if (
      tipoNeg === "AV" &&
      simulacaoAV?.cpfcnpj &&
      simulacaoAV.regrassimularacordo.dias_primeira_parcela_max
    ) {
      return format(
        addDays(
          new Date(),
          Number(simulacaoAV.regrassimularacordo.dias_primeira_parcela_max) - 1
        ),
        "yyyy-MM-dd"
      );
    } else {
      return format(addDays(new Date(), 30 - 1), "yyyy-MM-dd");
    }
  }

  function quantidadeParcelas() {
    let qtd: number[] = [];

    const maximo =
      Number(simulacaoAP?.regrassimularacordo?.quantidade_parcelas_max) || 1;
    for (let index = 1; index < maximo; index++) {
      qtd = [...qtd, index + 1];
    }

    return qtd.map((q) => (
      <option key={q} value={q}>
        {q}
      </option>
    ));
  }

  function quantidadesParcelasArray() {
    let pacelas: number[] = [];
    if (simulacaoAPJP?.regrassimularacordo?.length > 0) {
      for (
        let index = 0;
        index < simulacaoAPJP.regrassimularacordo?.length;
        index++
      ) {
        pacelas = [
          ...pacelas,
          Number(
            simulacaoAPJP.regrassimularacordo[index].quantidade_parcelas_max
          ),
        ];
      }
    }
    return pacelas.map((q) => (
      <option key={q} value={q}>
        {q}
      </option>
    ));
  }

  function formatDate(date: string) {
    const [ano, mes, dia] = date.split("-");
    const dataFormatada = `${dia}/${mes}/${ano}`;
    return dataFormatada;
  }

  function validacaoDescontos() {
    const s = tipoNeg === "AV" ? simulacaoAV : simulacaoAP;
    const des =
      Number(descontos?.percentual_desconto.replace(",", ".")) <=
      converterParaNumeroAmericano(
        s?.regrassimularacordo?.percentual_desconto_max
      ) &&
      Number(descontos?.percentual_desconto.replace(",", ".")) >=
      converterParaNumeroAmericano(
        s?.regrassimularacordo.percentual_desconto_min
      );

    const juros =
      Number(descontos?.percentual_isencaojuros.replace(",", ".")) <=
      converterParaNumeroAmericano(
        s?.regrassimularacordo?.percentual_isencaojuros_max
      ) &&
      Number(descontos?.percentual_desconto.replace(",", ".")) >=
      converterParaNumeroAmericano(
        s?.regrassimularacordo.percentual_isencaojuros_min
      );

    const multa =
      Number(descontos?.percentual_isencaomulta.replace(",", ".")) <=
      converterParaNumeroAmericano(
        s?.regrassimularacordo?.percentual_isencaomulta_max
      ) &&
      Number(descontos?.percentual_desconto.replace(",", ".")) >=
      converterParaNumeroAmericano(
        s?.regrassimularacordo.percentual_isencaomulta_min
      );

    const entradaVlr =
      Number(percentualEntrada.replace(",", ".")) <=
      converterParaNumeroAmericano(
        s?.regrassimularacordo?.percentual_entrada_max
      ) &&
      Number(percentualEntrada.replace(",", ".")) >=
      converterParaNumeroAmericano(
        s?.regrassimularacordo.percentual_entrada_min
      );
    // console.log(descontos?.percentual_isencaojuros, converterParaNumeroAmericano(s?.regrassimularacordo?.percentual_isencaojuros_max))
    // console.log(juros)

    // console.log(Number(descontos?.percentual_isencaomulta.replace(',', '.')), multa, des, entradaVlr)

    if (tipoNeg === "AP" && !entradaVlr) {
      setModal(
        "Os valores de desconto estão divergentes das regras!",
        "Erro",
        false,
        true
      );
      return false;
    }

    if (!juros || !multa || !des) {
      setModal(
        "Os valores de desconto estão divergentes das regras!",
        "Erro",
        false,
        true
      );
      return false;
    }
    return true;
  }

  async function simularAcordo() {
    const result = validacaoDescontos();

    if (!result) return;

    const dataSimular: RequestSimularParametros = {
      url: selectedCredor?.url_ws,
      cpf_cnpj: devedor?.cpf_cnpj,
      codcredor: String(selectedCredor?.credor_crm),
      usuario: String(cookies?.user?.id_operador),
      parcelamentos: [
        {
          tipo: tipoNeg,
          qtdeparcela:
            tipoNeg === "AP" ? String(Number(qtdParcelas) + 1) : qtdParcelas,
          valorentrada: tipoNeg === "AV" ? "0" : valorEntrada,
          vencimento: formatDate(vencimento),
          formapagamento: formaPagamento === "Boleto" ? "1" : "4",
          percentual_desconto: descontos?.percentual_desconto.replace(".", ","),
          percentual_isencaojuros: descontos?.percentual_isencaojuros.replace(
            ".",
            ","
          ),
          percentual_isencaomulta: descontos?.percentual_isencaomulta.replace(
            ".",
            ","
          ),
          percentual_juros_renegociacao:
            descontos?.percentual_juros_renegociacao.replace(".", ","),
        },
      ],
      contratos: parcelasNeg?.map((p) => {
        return {
          idparcial: p.idparcial,
          numcontrato: p.contrato,
          valpago: p.valorpago,
          filial: p.filial,
          datvenci: p.datvenci,
          numeroparcela: p.numeroparcela,
          identificador: "",
        };
      }),
      app
    };
    // console.log(formaPagamento)
    await calcularValores(dataSimular);
    goToOpeningAccordion("resumo")
  }

  function formatDateVenci(date?: string) {
    if (date && date !== '-') {
      const [ano, mes, dia] = date.split('-')
      return `${mes}/${dia}/${ano}`
    }
    return '-'
  }

  // console.log(simulcaoCalculadora)

  return (
    <div className="flex max-h-full flex-col items-center px-2">
      {!devedor?.cpf_cnpj &&
        !devedorCadastro?.dadoscadastrais &&
        devedor !== null ? (
        <div className="w-full text-center font-bold text-primary">
          <h3>
            Clique duas vezes em um dos devedores ao lado para iniciar o
            atendimento!
          </h3>
        </div>
      ) : !devedorCadastro?.dadoscadastrais && devedor === null ? (
        <div className="w-full text-center font-bold text-primary">
          <h3>Esse cliente nao está cadastrado em nosso banco de dados!</h3>
        </div>
      ) : (
        <>
          <ClienteInfo />

          <h3 className="text-lg font-semibold text-gray-700" id="neg-title">
            Detalhamento contrato(s)
          </h3>

          {contratosData && contratosData?.contratos?.length === 1 ? (
            <></>
          ) : (
            <div className="mt-4 flex w-full items-center justify-between px-2 text-sm">
              <div className="flex  items-center gap-2">
                <p>Permite junção: </p>
                <img src={handGreenIcon} alt="" />
              </div>

              <div className="flex  items-center gap-2">
                <p>Não permite junção: </p>
                <img src={handRedIcon} alt="" />
              </div>
            </div>
          )}
          <div className="mt-4 w-full">
            <h5 className="font-semibold text-sm text-gray-700">Selecione o contrato para simular:</h5>
          </div>

          <div className="my-2 w-full">
            {/* Contrato  */}
            <ContratoData
              simulacao={tipoNeg === "AV" ? simulacaoAV : simulacaoAP}
              tipoNeg={tipoNeg}
              app={app}
            />
            {/* {tipoNeg === 'AP' && credoresGazin.find(item => item === selectedCredor?.credor_crm) ? simulacaoAP?.regrassimularacordo?.valoratualdivida : valoresSimulacao?.valorCorrigido} */}
            <p className="-mb-4 font-medium text-primary underline">
              Valores Atualizados da Dívida
            </p>
            <div className="my-4 grid w-full grid-cols-2 place-content-center gap-4 rounded-sm border p-4 text-sm font-medium text-gray-800 outline-none">
              <div className="flex flex-col ">
                <p>Valor Original: </p>
                <p className="p-simulacao-azul">
                  R$ {valoresSimulacao?.valorOriginal}
                </p>
                <p className="mt-2">Valor Juros: </p>
                <p className="p-simulacao-azul">R$ {valoresSimulacao?.juros}</p>
              </div>
              <div className="flex flex-col ">
                <p>Valor Multa: </p>
                <p className="p-simulacao-azul">R$ {valoresSimulacao?.multa}</p>
                <p className="mt-2">Total Corrigido: </p>
                <p className="p-simulacao-azul">
                  R$ {valoresSimulacao?.valorCorrigido}{" "}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-6 text-sm">
              {/* Calculo dos valores do contrato */}
              <div className="flex items-center gap-2">
                <p>Qtd. de contrato(s): </p>
                <input
                  type="text"
                  placeholder={`${contratosData?.contratos?.length}`}
                  className="w-10 bg-gray-200 px-2 py-0.5 font-medium outline-none"
                  disabled
                />
                <input
                  type="text"
                  className="w-10 bg-blue-200 px-2 py-0.5 font-medium outline-none"
                  disabled
                  placeholder={`${contratoNeg?.numcontrato ? "1" : 0}`}
                />

                {/* <div className="bg-blue-200 px-2 ">
        <p className="font-medium">0</p>
      </div> */}
              </div>
              <div className="flex items-center gap-2">
                <p>Qtd. de parcela(s): </p>
                {/* <div className="bg-gray-200 px-2  ">
        <p className="font-medium">0</p>
      </div> */}
                <input
                  type="text"
                  placeholder={`${contratosData &&
                    contratosData?.contratos &&
                    contratosData?.contratos.length > 0
                    ? contratosData?.contratos[0]?.quantidadeParcelas
                    : 0
                    }`}
                  className="w-10 bg-gray-200 px-2 py-0.5 font-medium outline-none"
                  disabled
                />
                <input
                  type="text"
                  placeholder={`${parcelasNeg?.length}`}
                  className="w-10 bg-blue-200 px-2 py-0.5 font-medium outline-none"
                  disabled
                />
              </div>
            </div>

            <div className="flex items-center gap-4 py-4">
              <div className="flex flex-col  ">
                <p className=" font-medium ">Tipo Negociação: </p>
                <select
                  className="w-full bg-gray-200 p-1"
                  onChange={(e) => setTipoNeg(e.target.value)}
                  value={tipoNeg}
                >
                  <option value="AV">AV</option>
                  {/* <option value="AP">AP</option> */}
                </select>
              </div>
              <div className="flex flex-col ">
                <p className=" font-medium ">Qtd. Parcela:</p>
                <select
                  className="w-full bg-gray-200 p-1"
                  name=""
                  id=""
                  onChange={(e) => setQtdParcelas(e.target.value)}
                  value={qtdParcelas}
                >
                  {tipoNeg === "AP" &&
                    simulacaoAP?.cpfcnpj &&
                    simulacaoAP?.codcredor !== "2000" ? (
                    quantidadeParcelas()
                  ) : tipoNeg === "AP" &&
                    simulacaoAP?.cpfcnpj &&
                    simulacaoAP?.codcredor === "2000" ? (
                    quantidadesParcelasArray()
                  ) : (
                    <option value="1">1</option>
                  )}
                </select>
              </div>
              <button
                className={`mt-4 flex items-center gap-2 rounded bg-cyan-500 p-2 font-medium text-gray-800 ${contratoNeg?.permiteacordo &&
                  "cursor-disable pointer-events-none"
                  }`}
                onClick={() => paramsSimulate()}
              >
                <IoSearch size={18} className="fill-gray-800" />
                <p>Buscar Parâmetros</p>
              </button>
            </div>

            <div className="my-4 grid w-full grid-cols-3 place-content-center gap-4 rounded-sm border p-4 text-sm text-gray-800 outline-none">
              {/* inputs de tipo de negociação */}

              <div className="flex flex-col ">
                <p className=" font-medium ">Valor Entrada/AV: </p>
                <input
                  type="text"
                  className="w-full bg-gray-200 p-1 outline-none"
                  value={valorEntrada}
                  // onChange={e => setValorEntrada(e.target.value)}
                  disabled
                />
              </div>

              <div className="flex  flex-col">
                <p className="font-medium ">Vencimento:</p>
                <input
                  type="date"
                  className="w-full bg-gray-200 p-1  outline-none"
                  min={format(new Date(), "yyyy-MM-dd")}
                  max={getMaxDays()}
                  value={vencimento}
                  onChange={(e) => {
                    if (!isToday(new Date(formatDateVenci(e.target.value))) && formaPagamento === 'PIX') {
                      setFormaPagamento("Pgto em loja")
                    }
                    setVencimento(e.target.value)
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                  disabled={!contratoNeg?.numcontrato}
                />
              </div>
              <div className="flex flex-col ">
                <p className=" font-medium ">Forma Pagamento: </p>
                <select
                  className="w-full bg-gray-200 p-1"
                  value={formaPagamento}
                  onChange={(e) => setFormaPagamento(e.target.value)}
                >
                  <option value="Pgto em loja">PGTO EM LOJA</option>
                  {/* <option value="Boleto">BOLETO</option> */}
                  {isToday(new Date(formatDateVenci(vencimento))) && <option value="PIX">PIX</option>}
                </select>
              </div>
            </div>

            <div className="my-4">
              <p className="mb-2 w-full text-center text-lg font-medium text-gray-800">
                Simulação
              </p>
              <ParametroSimulacao
                simulacao={tipoNeg === "AV" ? simulacaoAV : simulacaoAP}
                tipoNeg={tipoNeg}
              />
            </div>

            <div className="my-4 flex items-center justify-center gap-2 border p-2">
              <p className="font-semibold text-primary">
                Resultado do Cálculo:{" "}
              </p>
              {simulcaoCalculadora?.cpfcnpj && (
                <p className="text-sm font-medium text-gray-800">
                  {simulcaoCalculadora?.propostas?.proposta.descricao} Vencendo
                  em: {formatDate(vencimento)}
                </p>
              )}
            </div>

            <div className="mb-4 flex items-center gap-4">
              <button
                className={`flex w-full items-center justify-center gap-2 rounded bg-title-blue p-2 px-4 text-center text-white ${contratoNeg?.permiteacordo &&
                  "cursor-disable pointer-events-none"
                  } disabled:opacity-50`}
                onClick={() => simularAcordo()}
                disabled={parcelasNeg?.length === 0}
              >
                <img src={calculadoraIcon} alt="" />
                Calcular valores
              </button>

              <button
                onClick={() => goToOpeningAccordion("resumo")}
                className="flex w-full items-center justify-center gap-2 rounded bg-primary p-2 px-4 text-white disabled:opacity-50"
                disabled={parcelasNeg?.length === 0}
              >
                Resumo do Acordo
              </button>

              {/* <button
                    onClick={() => setModal("Tabulação", "Cadastro")}
                    className="flex w-full items-center justify-center gap-2 rounded bg-primary p-2 px-4 text-white"
                  >
                    
                    Tabulação
                  </button> */}
            </div>
            {/* <Button name="Sela acordo" /> */}

            <CanaisEnvio formaPag={formaPagamento} />

            <div className="my-4 w-full">
              <ResumoAcordo formaPag={formaPagamento} vencimento={vencimento} app={app} />
            </div>
          </div>

          <GenericModal
            title={modalInfo.title}
            type={modalInfo.type}
            onClose={() => onClose()}
            show={modalInfo.isOpen && modalInfo.title === "Erro Acordo"}
            modalType="Erro Acordo"
            app={app}
          />

          <GenericModal
            title={modalInfo.title}
            type={modalInfo.type}
            onClose={() => onClose()}
            show={modalInfo.isOpen && modalInfo.title === "Proximo Atendimento"}
            modalType="Proximo Atendimento"
            app={app}
          />

          <GenericModal
            title={modalInfo.title}
            type={modalInfo.type}
            onClose={() => onClose()}
            show={modalInfo.isOpen}
            modalType="Cadastro Contato"
            isToSave
            app={app}
          />

          <ModalAviso message="Contrato com acordo vigente. Emita a segunda via." />
        </>
      )}
    </div>
  );
};
